<!--
  The host's Trustpilot badge is projected in both arms. Control: the wrappers
  are `display: contents`, so the badge renders exactly where the host put it.
  Test: it joins the coverage link in one trust row.
-->
<div class="wrapper" [class.damage-compensation-line]="show()">
  @if (show()) {
    <a class="coverage" [href]="'damage-compensation' | seoRoute">
      <span class="badge" aria-hidden="true">
        <ui-icon name="security-check" variant="stroke" />
      </span>
      <span class="text">
        <span class="title">
          {{
            'COMPONENTS.DAMAGE_COMPENSATION_LINE.TITLE'
              | translate
                : { maxAmount: (compensationMaximum() | formatCurrency) }
          }}
        </span>
        <span class="link">
          {{ 'COMPONENTS.DAMAGE_COMPENSATION_LINE.LINK' | translate }}
          <ui-icon name="arrow-right-01" variant="stroke" />
        </span>
      </span>
    </a>
  }
  <div class="trust"><ng-content /></div>
</div>
